import { render, staticRenderFns } from "./mdm-form-report-data-row.vue?vue&type=template&id=5cfd3bf2&"
import script from "./mdm-form-report-data-row.vue?vue&type=script&lang=js&"
export * from "./mdm-form-report-data-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports